export default "__VITE_ASSET__CHT3B53u__"